import { useMutation } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { IterationDetailsFormValues } from 'schemas/Iteration.schema.ts';
import { apiFetch } from 'utils/apiUtils.ts';

interface UpdateIterationBody {
  message: string,
  ID: string,
  Version: number
}

interface UpdateIterationVariables {
  teamId: string,
  campaignId: string,
  iterationId: string,
  iteration: IterationDetailsFormValues,
}

export default function useUpdateIteration() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({
      teamId,
      campaignId,
      iterationId,
      iteration,
    }: UpdateIterationVariables) => apiFetch<UpdateIterationBody>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: iteration,
    }),
  });
}
